var reguaFio = new Swiper(".regua-fio-wraper.swiper", {
  slidesPerView: 1,
  spaceBetween: 16,
  loop: false,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  updateOnWindowResize: true,
  centeredSlides: false,
  allowTouchMove: true,
  touchRatio: 1,
  grabCursor: true,
  pagination: {
    el: '.regua-fio.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 16,
      centeredSlides: false,
      allowTouchMove: true,
      loop: false,
      pagination: {
        el: '.regua-fio.swiper-pagination',
        clickable: true,
      },
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 16,
      centeredSlides: false,
      allowTouchMove: true,
      loop: false,
      pagination: {
        el: '.regua-fio.swiper-pagination',
        clickable: true,
      },
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 24,
      centeredSlides: false,
      allowTouchMove: true,
      loop: false,
      pagination: {
        el: '.regua-fio.swiper-pagination',
        clickable: true,
      },
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 32,
      centeredSlides: false,
      enabled: false,
      allowTouchMove: false,
      loop: false,
      autoplay: false
    }
  },
});
